import { createSelector } from '@reduxjs/toolkit';
import { alphaSort } from 'vet-bones/utils';
import { createSelectItem } from 'vet-bones/utils/select';

import { isModelConceptClass } from 'src/containers/ProjectDiagram/utils/data';
import { getLabelForIri } from 'src/containers/ProjectDiagram/utils/labels';
import { projectLabelsByIriSelector } from 'src/selectors/projectLabelsByIri';
import { projectNodeDataArraySelector } from 'src/selectors/projectNodeDataArray';
import * as copy from 'src/templates/copy';

export const projectClassItemsSelector = (projectId: string) =>
  createSelector(
    projectLabelsByIriSelector(projectId),
    projectNodeDataArraySelector(projectId),
    (labelsByIri, nodeDataArray) =>
      nodeDataArray
        .filter((data) => isModelConceptClass(data))
        .map((data) =>
          createSelectItem(
            getLabelForIri(
              labelsByIri,
              data.value,
              copy.components.projectDiagram.modelConceptClass.new
            ),
            data.value
          )
        )
        .sort(alphaSort((item) => item.text))
  );
